require('./mortgageRequestOtherLoans.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { isEqual, isNull } = require('lodash/lang');
const classNames = require('classnames');
//core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;
//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
//@components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { AmountInput } = require('commonsComponents/amountInput');
// @constants
const { EURO_SYMBOL, YES, NO } = require('constants/index');
const { HOLDER_OPTION_ONE, HOLDER_OPTION_TWO } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;

const {
    mortgagesRequestOtherLoansCommons: {
        MONTHLY_FEES_LOANS,
        PENDING_AMOUNT_LOANS,
        PERSONAL_LOANS,
        OTHER_MORTGAGE,
        GOING_CANCEL_MORTGAGE,
        MONTHLY_FEES_MORTGAGE,
        PENDING_AMOUNT_MORTGAGE,
        LOANS,
        MORTGAGES
    }
} = require('constants/mortgageRequestPreApproval');


class MortgageRequestOtherLoans extends React.Component {
    validateStateFieldsPersonalLoans(isSecondHolder) {
        const { immMortgageRequest } = this.props;
        const personalLoansValueOne = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, PERSONAL_LOANS]);
        const personalLoansValueTwo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, PERSONAL_LOANS]);
        const response = {
            disabledMonthlyAndPendingAmountPersonalLoansOne: true,
            disabledMonthlyAndPendingAmountPersonalLoansTwo: true
        }

        if (isEqual(personalLoansValueOne, NO) && isEqual(personalLoansValueTwo, NO)
            || isEqual(personalLoansValueOne, '') && isEqual(personalLoansValueTwo, '')
            || isNull(personalLoansValueOne) && isNull(personalLoansValueTwo)) {
            this.clearValuesPersonalLoans(true, true);
            return response;
        } else if (isEqual(personalLoansValueOne, NO) || isEqual(personalLoansValueOne, '') || isNull(personalLoansValueOne)) {
            if (isSecondHolder) {
                if (isEqual(personalLoansValueTwo, NO) || isEqual(personalLoansValueTwo, '') || isNull(personalLoansValueTwo)) {
                    this.clearValuesPersonalLoans(true, true);
                    response.disabledMonthlyAndPendingAmountPersonalLoansOne = true;
                    response.disabledMonthlyAndPendingAmountPersonalLoansTwo = true;
                } else {
                    this.clearValuesPersonalLoans(true, false);
                    response.disabledMonthlyAndPendingAmountPersonalLoansOne = true;
                    response.disabledMonthlyAndPendingAmountPersonalLoansTwo = false;
                }

            } else {
                this.clearValuesPersonalLoans(false, true);
            }
            return response;
        } else if (isEqual(personalLoansValueTwo, NO) || isEqual(personalLoansValueTwo, '') || isNull(personalLoansValueTwo)) {
            this.clearValuesPersonalLoans(false, true);
            response.disabledMonthlyAndPendingAmountPersonalLoansOne = false;
            response.disabledMonthlyAndPendingAmountPersonalLoansTwo = true;
            return response;
        } else {
            response.disabledMonthlyAndPendingAmountPersonalLoansOne = false;
            response.disabledMonthlyAndPendingAmountPersonalLoansTwo = false;
            return response;
        }

    }

    validateStateFieldsOtherMortgages(isSecondHolder) {
        const { immMortgageRequest } = this.props;
        const firstHolderHaveOtherMortgages = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, OTHER_MORTGAGE]);
        const secondHolderHaveOtherMortgages = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, OTHER_MORTGAGE]);
        const firstHolderGoingToCancelMortgage = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, GOING_CANCEL_MORTGAGE]);
        const secondHolderGoingToCancelMortgage = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, GOING_CANCEL_MORTGAGE]);
        const clearSecondHolderOtherMortgagesValues = (
            secondHolderHaveOtherMortgages === NO ||
            secondHolderHaveOtherMortgages === '' ||
            secondHolderGoingToCancelMortgage === YES
        );
        const response = {
            disabledGoingCancelMortgageOne: true,
            disabledGoingCancelMortgageTwo: true,
            disabledMonthlyAndPendingAmountOne: true,
            disabledMonthlyAndPendingAmountTwo: true
        };

        if (clearSecondHolderOtherMortgagesValues) {
            this.clearOtherMortgagesInputs(false, false, false, true);
        }

        if (isEqual(firstHolderHaveOtherMortgages, NO) && isEqual(secondHolderHaveOtherMortgages, NO) ||
            isEqual(firstHolderHaveOtherMortgages, '') && isEqual(secondHolderHaveOtherMortgages, '')
            || isNull(firstHolderHaveOtherMortgages) && isNull(secondHolderHaveOtherMortgages)) {
            this.clearOtherMortgagesInputs(true, true, true, true);
            return response;
        } else if (isEqual(firstHolderHaveOtherMortgages, NO) || isEqual(firstHolderHaveOtherMortgages, '') || isNull(firstHolderHaveOtherMortgages)) {
            if (isSecondHolder) {
                if (isEqual(secondHolderGoingToCancelMortgage, NO) || isNull(secondHolderGoingToCancelMortgage)) {
                    response.disabledGoingCancelMortgageOne = true;
                    response.disabledGoingCancelMortgageTwo = false;
                    response.disabledMonthlyAndPendingAmountOne = true;
                    response.disabledMonthlyAndPendingAmountTwo = false;
                    this.clearOtherMortgagesInputs(true, true, false, false);
                } else if (isEqual(secondHolderHaveOtherMortgages, '') || isNull(secondHolderHaveOtherMortgages)) {
                    response.disabledGoingCancelMortgageOne = true;
                    response.disabledGoingCancelMortgageTwo = true;
                    response.disabledMonthlyAndPendingAmountOne = true;
                    response.disabledMonthlyAndPendingAmountTwo = true;
                    this.clearOtherMortgagesInputs(true, true, true, true);
                } else if (isEqual(firstHolderHaveOtherMortgages, '') || isNull(firstHolderHaveOtherMortgages)) {
                    this.clearOtherMortgagesInputs(true, true, true, true);
                    response.disabledMonthlyAndPendingAmountOne = true;
                    response.disabledMonthlyAndPendingAmountTwo = true;
                    response.disabledGoingCancelMortgageOne = true;
                    response.disabledGoingCancelMortgageTwo = true;
                } else {
                    this.clearOtherMortgagesInputs(true, true, false, true);
                    response.disabledMonthlyAndPendingAmountOne = true;
                    response.disabledMonthlyAndPendingAmountTwo = true;
                    response.disabledGoingCancelMortgageOne = true;
                    response.disabledGoingCancelMortgageTwo = false;
                }
                return response;
            } else {
                return response;
            }
        } else if (isEqual(secondHolderHaveOtherMortgages, NO) || isEqual(secondHolderHaveOtherMortgages, '') || isNull(secondHolderHaveOtherMortgages)) {
            response.disabledGoingCancelMortgageOne = false;
            response.disabledGoingCancelMortgageTwo = true;

            if ((isEqual(firstHolderGoingToCancelMortgage, YES) || isEqual(firstHolderGoingToCancelMortgage, '')) &&
                (isEqual(secondHolderGoingToCancelMortgage, YES) || isEqual(secondHolderGoingToCancelMortgage, ''))) {
                this.clearOtherMortgagesInputs(false, true, true, true);
                response.disabledMonthlyAndPendingAmountOne = true;
                response.disabledMonthlyAndPendingAmountTwo = true;
            } else if (isEqual(firstHolderGoingToCancelMortgage, YES)) {
                this.clearOtherMortgagesInputs(false, true, true, false);
                response.disabledMonthlyAndPendingAmountOne = true;
                response.disabledMonthlyAndPendingAmountTwo = false;
            } else if (isEqual(secondHolderGoingToCancelMortgage, YES)) {
                this.clearOtherMortgagesInputs(false, false, true, true);
                response.disabledMonthlyAndPendingAmountOne = false;
                response.disabledMonthlyAndPendingAmountTwo = true;
            } else if (isEqual(firstHolderGoingToCancelMortgage, NO) || isEqual(secondHolderGoingToCancelMortgage, '')) {
                this.clearOtherMortgagesInputs(false, false, true, false);
                response.disabledMonthlyAndPendingAmountOne = false;
                response.disabledMonthlyAndPendingAmountTwo = true;
            } else {
                this.clearOtherMortgagesInputs(false, false, true, false);
                response.disabledMonthlyAndPendingAmountOne = false;
                response.disabledMonthlyAndPendingAmountTwo = false;
            }
            return response;
        } else {
            response.disabledGoingCancelMortgageOne = false;
            response.disabledGoingCancelMortgageTwo = false;

            if ((isEqual(firstHolderGoingToCancelMortgage, YES) || isEqual(firstHolderGoingToCancelMortgage, '')) &&
                (isEqual(secondHolderGoingToCancelMortgage, YES) || isEqual(secondHolderGoingToCancelMortgage, ''))) {
                this.clearOtherMortgagesInputs(false, true, false, true);
                response.disabledMonthlyAndPendingAmountOne = true;
                response.disabledMonthlyAndPendingAmountTwo = true;
            } else if (isEqual(firstHolderGoingToCancelMortgage, YES) || isEqual(firstHolderGoingToCancelMortgage, '')) {
                this.clearOtherMortgagesInputs(false, true, false, false);
                response.disabledMonthlyAndPendingAmountOne = true;
                response.disabledMonthlyAndPendingAmountTwo = false;
            } else if (isEqual(secondHolderGoingToCancelMortgage, YES) || isEqual(secondHolderGoingToCancelMortgage, '')) {
                this.clearOtherMortgagesInputs(false, false, false, true);
                response.disabledMonthlyAndPendingAmountOne = false;
                response.disabledMonthlyAndPendingAmountTwo = true;
            } else {
                response.disabledMonthlyAndPendingAmountOne = false;
                response.disabledMonthlyAndPendingAmountTwo = false;
            }
            return response;
        }
    }

    clearValuesPersonalLoans(clearFirstHolderValues, clearSecondHolderValues) {
        const { formHandlers } = this.props;
        if (clearFirstHolderValues) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_ONE, MONTHLY_FEES_LOANS, '');
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_ONE, PENDING_AMOUNT_LOANS, '');
        }
        if (clearSecondHolderValues) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_TWO, MONTHLY_FEES_LOANS, '');
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_TWO, PENDING_AMOUNT_LOANS, '');
        }
    }

    clearOtherMortgagesInputs(clearFirstHolderRadio, clearFirstHolderInput, clearSecondHolderRadio, clearSecondHolderInput) {
        const { formHandlers } = this.props;

        if (clearFirstHolderRadio) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_ONE, GOING_CANCEL_MORTGAGE, '');
        }
        if (clearFirstHolderInput) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_ONE, MONTHLY_FEES_MORTGAGE, '');
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_ONE, PENDING_AMOUNT_MORTGAGE, '');
        }
        if (clearSecondHolderRadio) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_TWO, GOING_CANCEL_MORTGAGE, '');
        }
        if (clearSecondHolderInput) {
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_TWO, MONTHLY_FEES_MORTGAGE, '');
            formHandlers.handlerInfoOtherLoansMortgages(HOLDER_OPTION_TWO, PENDING_AMOUNT_MORTGAGE, '');
        }
    }


    validateFees(typeHolder, type) {
        const { immMortgageRequest } = this.props;
        let valid;
        const monthlyFees = immMortgageRequest.getIn(['holders', typeHolder, `monthlyFees${type}`]);
        const pendingAmount = immMortgageRequest.getIn(['holders', typeHolder, `pendingAmount${type}`]);
        const monthlyFeesValue = Number.isInteger(monthlyFees) ? monthlyFees : 0;
        const pendingAmountValue = Number.isInteger(pendingAmount) ? pendingAmount : '';

        if(pendingAmountValue === '') return true;

        if (typeHolder === HOLDER_OPTION_ONE) {
            valid = monthlyFeesValue && pendingAmountValue && monthlyFeesValue <= pendingAmountValue;
        } else {
            valid = monthlyFeesValue && pendingAmountValue && monthlyFeesValue <= pendingAmountValue;
        }
        return valid;
    }

    buildMonthlyFeesLoans(typeHolder, disableProp) {
        const { formHandlers, immMortgageRequest } = this.props;
        const amount = immMortgageRequest.getIn(['holders', typeHolder, MONTHLY_FEES_LOANS]);
        const valid = (!amount || isEqual(amount, '0')) ? true : this.validateFees(typeHolder, LOANS);
        const errorFeesLoans = formatText("mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_ValidFeesLoans");

        return (
            <div className="mortgage-request-other-loans__input">
                <AmountInput
                    onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, MONTHLY_FEES_LOANS, parseFloat(value) || 0.0) }}
                    id={`monthly-fees-loans` + typeHolder}
                    name={`monthly-fees-loans` + typeHolder}
                    amount={amount}
                    callback={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, MONTHLY_FEES_LOANS, value) }}
                    disabled={disableProp}
                    min={0}
                    maxBackEndFractionLength={2}
                    keepZeroAndEmpty
                    showBlurZero
                    fluid
                    language={getLanguage()}
                    error={!disableProp && !valid}
                    errorMsg={errorFeesLoans}
                />
                <span className="mortgage-request-other-loans__euro-span">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildPendingAmountLoans(typeHolder, disableProp) {
        const { formHandlers, immMortgageRequest } = this.props;
        return (
            <div className="mortgage-request-other-loans__input">
                <AmountInput
                    onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, PENDING_AMOUNT_LOANS, parseFloat(value) || 0.0) }}
                    id={`pending-amount-loans` + typeHolder}
                    name={`pending-amount-loans` + typeHolder}
                    amount={immMortgageRequest.getIn(['holders', typeHolder, PENDING_AMOUNT_LOANS])}
                    callback={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, PENDING_AMOUNT_LOANS, value) }}
                    disabled={disableProp}
                    min={0}
                    maxBackEndFractionLength={2}
                    keepZeroAndEmpty
                    showBlurZero
                    fluid
                    language={getLanguage()}
                />
                <span className="mortgage-request-other-loans__euro-span">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildPersonalLoansRadio(typeHolder) {
        const { formHandlers, immMortgageRequest } = this.props;
        const firstRadioLabel = (<FormattedText value="common-yes" format="camelCase" />);
        const secondRadioLabel = (<FormattedText value="common-no" format="camelCase" />);
        return (
            <RadioButtonGroup
                onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, PERSONAL_LOANS, value) }}
                name={`personal-loans` + typeHolder}
                idPrefix={`personal-loans` + typeHolder}
                selectedValue={immMortgageRequest.getIn(['holders', typeHolder, PERSONAL_LOANS])}
            >
                <RadioButton label={firstRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={YES} />
                <RadioButton label={secondRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={NO} />
            </RadioButtonGroup>
        );
    }

    buildOtherMortgageRadio(typeHolder) {
        const { formHandlers, immMortgageRequest } = this.props;
        const firstRadioLabel = (<FormattedText value="common-yes" format="camelCase" />);
        const secondRadioLabel = (<FormattedText value="common-no" format="camelCase" />);
        return (
            <RadioButtonGroup
                onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, OTHER_MORTGAGE, value) }}
                name={`other-mortgage` + typeHolder}
                idPrefix={`other-mortgage` + typeHolder}
                selectedValue={immMortgageRequest.getIn(['holders', typeHolder, OTHER_MORTGAGE])}
            >
                <RadioButton label={firstRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={YES} />
                <RadioButton label={secondRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={NO} />
            </RadioButtonGroup>
        );
    }

    buildGoingCancelMortgageRadio(typeHolder, disableProp) {
        const { formHandlers, immMortgageRequest } = this.props;
        const firstRadioLabel = (<FormattedText value="common-yes" format="camelCase" />);
        const secondRadioLabel = (<FormattedText value="common-no" format="camelCase" />);
        return (
            <RadioButtonGroup
                onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, GOING_CANCEL_MORTGAGE, value) }}
                name={`going-cancel-mortgage` + typeHolder}
                idPrefix={`going-cancel-mortgage` + typeHolder}
                selectedValue={immMortgageRequest.getIn(['holders', typeHolder, GOING_CANCEL_MORTGAGE])}
            >
                <RadioButton label={firstRadioLabel} disabled={disableProp} className="col-sm-6 calculate-quota__radio-container" value={YES} />
                <RadioButton label={secondRadioLabel} disabled={disableProp} className="col-sm-6 calculate-quota__radio-container" value={NO} />
            </RadioButtonGroup>
        );
    }

    buildMonthlyFeesMortgages(typeHolder, disableProp) {
        const { formHandlers, immMortgageRequest } = this.props;
        const amount = immMortgageRequest.getIn(['holders', typeHolder, MONTHLY_FEES_MORTGAGE]);
        const valid = (!amount || isEqual(amount, '0')) ? true : this.validateFees(typeHolder, MORTGAGES);
        const errorFeesMortgages = formatText("mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_ValidFeesLoans");

        return (
            <div className="mortgage-request-other-loans__input">
                <AmountInput
                    onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, MONTHLY_FEES_MORTGAGE, parseFloat(value) || 0.0) }}
                    id={`monthly-fees-mortgages` + typeHolder}
                    name={`monthly-fees-mortgages` + typeHolder}
                    amount={amount}
                    callback={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, MONTHLY_FEES_MORTGAGE, value) }}
                    disabled={disableProp}
                    min={0}
                    maxBackEndFractionLength={2}
                    keepZeroAndEmpty
                    showBlurZero
                    fluid
                    language={getLanguage()}
                    error={!disableProp && !valid}
                    errorMsg={errorFeesMortgages}
                />
                <span className="mortgage-request-other-loans__euro-span">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildPendingAmountMortgages(typeHolder, disableProp) {
        const { formHandlers, immMortgageRequest } = this.props;

        return (
            <div className="mortgage-request-other-loans__input">
                <AmountInput
                    onChange={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, PENDING_AMOUNT_MORTGAGE, parseFloat(value) || 0.0) }}
                    id={`pending-amount-mortgages` + typeHolder}
                    name={`pending-amount-mortgages` + typeHolder}
                    amount={immMortgageRequest.getIn(['holders', typeHolder, PENDING_AMOUNT_MORTGAGE])}
                    callback={value => { formHandlers.handlerInfoOtherLoansMortgages(typeHolder, PENDING_AMOUNT_MORTGAGE, value) }}
                    disabled={disableProp}
                    min={0}
                    maxBackEndFractionLength={2}
                    keepZeroAndEmpty
                    showBlurZero
                    fluid
                    language={getLanguage()}
                />
                <span className="mortgage-request-other-loans__euro-span">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildPersonalLoans(isSecondHolder) {
        const disabledProp = this.validateStateFieldsPersonalLoans(isSecondHolder);
        const cssColTitles = classNames(
            'mortgage-request-other-loans__container-title', {
                'col-md-5': isSecondHolder,
                'col-md-7': !isSecondHolder
            });

        const cssIsDisable = classNames('col-md-12', {
            'col-md-12 mortgage-request-other-loans__disable':
                disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne && disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo
        });

        const cssColRadios = classNames(
            'col-md-offset-1',
            'mortgage-request-other-loans__container-radio', {
                'col-md-3': isSecondHolder,
                'col-md-1': !isSecondHolder
            });

        const cssColInputs = classNames(
            'col-md-offset-1',
            'mortgage-request-other-loans__container-input', {
                'col-md-3': isSecondHolder,
                'col-md-1': !isSecondHolder
            });

        const firstPersonalLoansRadio = this.buildPersonalLoansRadio(HOLDER_OPTION_ONE);
        const secondPersonalLoansRadio = isSecondHolder ? this.buildPersonalLoansRadio(HOLDER_OPTION_TWO) : null;
        const firstMonthlyFeesLoans = this.buildMonthlyFeesLoans(HOLDER_OPTION_ONE, disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne);
        const secondMonthlyFeesLoans = isSecondHolder ? this.buildMonthlyFeesLoans(HOLDER_OPTION_TWO, disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo) : null;
        const firstPendingAmountLoans = this.buildPendingAmountLoans(HOLDER_OPTION_ONE, disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne);
        const secondPendingAmountLoans = isSecondHolder ? this.buildPendingAmountLoans(HOLDER_OPTION_TWO, disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo) : null;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className={cssColTitles}>
                        <FormattedText className="mortgage-request-other-loans__bold-title" value="mortgageRequestPreApproval-personalLoans" />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-radio">
                        {firstPersonalLoansRadio}
                    </div>
                    <div className={cssColRadios}>
                        {secondPersonalLoansRadio}
                    </div>
                </div>
                <div className={cssIsDisable}>
                    <div className={cssColTitles}>
                        <FormattedText
                            className="mortgage-request-other-loans__text mortgage-request-other-loans__text--small-width"
                            value="mortgageRequestPreApproval-mortgageRequestPreApproval_loansMonthlyFees"
                        />
                        <FormattedText
                            className="mortgage-request-other-loans__subtitle"
                            value="mortgageRequestPreApproval-approximateAmount"
                        />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-input">
                        {firstMonthlyFeesLoans}
                    </div>
                    <div className={cssColInputs}>
                        {secondMonthlyFeesLoans}
                    </div>
                </div>
                <div className={cssIsDisable}>
                    <div className={cssColTitles}>
                        <FormattedText
                            className="mortgage-request-other-loans__text mortgage-request-other-loans__text--medium-width"
                            value="mortgageRequestPreApproval-mortgageRequestPreApproval_loansPendingAmount"
                        />
                        <FormattedText
                            className="mortgage-request-other-loans__subtitle"
                            value="mortgageRequestPreApproval-approximateAmount"
                        />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-input">
                        {firstPendingAmountLoans}
                    </div>
                    <div className={cssColInputs}>
                        {secondPendingAmountLoans}
                    </div>
                </div>
            </div>
        );
    }
    buildPersonalLoansResponisveHolder(isSecondHolder, holder) {
        const disabledProp = this.validateStateFieldsPersonalLoans(isSecondHolder, holder);
        const propsDisabledFields = this.validateStateFieldsOtherMortgages(isSecondHolder, holder);

        const cssIsDisable = classNames('col-sm-12 col-md-12 mortgage-request-other-loans-responsive__mb-2', {
            'col-md-12 mortgage-request-other-loans__disable':
                holder === HOLDER_OPTION_ONE
                    ? disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne
                    : disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo
        });

        const cssColTitles = classNames('col-sm-12 col-md-12 mortgage-request-other-loans-responsive__mb-1', {
            'col-md-12 mortgage-request-other-loans__disable':
                holder === HOLDER_OPTION_ONE
                    ? disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne
                    : disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo
        });

        const cssIsDisabledRadio = classNames(
            'col-sm-12 col-md-12 mortgage-request-other-loans-responsive__mb-1', {
            'mortgage-request-other-loans__disable':
                holder === HOLDER_OPTION_ONE
                    ? propsDisabledFields.disabledGoingCancelMortgageOne
                    : propsDisabledFields.disabledGoingCancelMortgageTwo
        });

        const cssIsDisabledOtherMortgagesSpan = classNames(
            'col-sm-12 col-md-12 mortgage-request-other-loans-responsive__mb-1', {
            'mortgage-request-other-loans__disable':
                holder === HOLDER_OPTION_ONE
                    ? propsDisabledFields.disabledMonthlyAndPendingAmountOne
                    : propsDisabledFields.disabledMonthlyAndPendingAmountTwo
        });

        const cssIsDisabledOhterMortgaggesInputs = classNames(
            'col-sm-12 col-md-12', {
            'mortgage-request-other-loans__disable':
                holder === HOLDER_OPTION_ONE
                    ? propsDisabledFields.disabledMonthlyAndPendingAmountOne
                    : propsDisabledFields.disabledMonthlyAndPendingAmountTwo
        });

        const monthlyFeesLoans = this.buildMonthlyFeesLoans(holder, holder === HOLDER_OPTION_ONE
            ? disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne
            : disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo);

        const pendingAmountLoans = this.buildPendingAmountLoans(holder, holder === HOLDER_OPTION_ONE
            ? disabledProp.disabledMonthlyAndPendingAmountPersonalLoansOne
            : disabledProp.disabledMonthlyAndPendingAmountPersonalLoansTwo);

        const otherMortgageRadio = this.buildOtherMortgageRadio(holder);

        const goingCancelMortgage = this.buildGoingCancelMortgageRadio(holder, holder === HOLDER_OPTION_ONE
            ? propsDisabledFields.disabledGoingCancelMortgageOne
            : propsDisabledFields.disabledGoingCancelMortgageTwo);

        const monthlyFeesMortgages = this.buildMonthlyFeesMortgages(holder, holder === HOLDER_OPTION_ONE
            ? propsDisabledFields.disabledMonthlyAndPendingAmountOne
            : propsDisabledFields.disabledMonthlyAndPendingAmountTwo);

        const pendingAmountMortgages = this.buildPendingAmountMortgages(holder, holder === HOLDER_OPTION_ONE
            ? propsDisabledFields.disabledMonthlyAndPendingAmountOne
            : propsDisabledFields.disabledMonthlyAndPendingAmountTwo);

        const personalLoansRadio = this.buildPersonalLoansRadio(holder);

        return (
            <>
                <div className="row">
                    <div className='col-sm-12'>
                        {isSecondHolder &&
                            <div className="mortgage-request-marital-status-and-dependents__label mortgage-request-other-loans-responsive__mb-2">
                                {holder === HOLDER_OPTION_ONE ?
                                    <FormattedText value="mortgageRequestPreApprovalStepThree-firstOwner" />
                                    :
                                    <FormattedText value="mortgageRequestPreApproval-secondtHolder" />
                                }
                            </div>
                        }
                    </div>
                    <div className='col-sm-12 mortgage-request-other-loans-responsive__mb-1'>
                        <FormattedText className="mortgage-request-other-loans__bold-title" value="mortgageRequestPreApproval-personalLoans" />
                    </div>
                    <div className='col-sm-12 mortgage-request-other-loans-responsive__mb-2'>
                        {personalLoansRadio}
                    </div>
                    <div className={cssColTitles}>
                        <span className='mortgage-request-other-loans-responsive__mr-1'>
                            {formatText("mortgageRequestPreApproval-mortgageRequestPreApproval_loansMonthlyFees")}
                        </span>
                        <span>
                            {formatText("mortgageRequestPreApproval-approximateAmount")}
                        </span>
                    </div>
                    <div className={cssIsDisable}>
                        <div className="mortgage-request-other-loans-responsive__container-input">
                            {monthlyFeesLoans}
                        </div>
                    </div>
                    <div className={cssColTitles}>
                        <span className='mortgage-request-other-loans-responsive__mr-1'>
                            {formatText("mortgageRequestPreApproval-mortgageRequestPreApproval_loansPendingAmount")}
                        </span>
                        <span>
                            {formatText("mortgageRequestPreApproval-approximateAmount")}
                        </span>
                    </div>
                    <div className={cssIsDisable}>
                        <div className="mortgage-request-other-loans-responsive__container-input">
                            {pendingAmountLoans}
                        </div>
                    </div>
                    <div className='col-sm-12 mortgage-request-other-loans-responsive__mb-1'>
                        <FormattedText className="mortgage-request-other-loans__bold-title" value="mortgageRequestPreApproval-otherMortgages" />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-radio mortgage-request-other-loans-responsive__mb-1">
                        {otherMortgageRadio}
                    </div>
                    <div className={cssIsDisabledRadio}>
                        <FormattedText
                            className="mortgage-request-other-loans__regular-title"
                            value="mortgageRequestPreApproval-goingCancelMortgage"
                        />
                    </div>
                    <div className={cssIsDisabledRadio} style={{ paddingLeft: 30 }}>
                        {goingCancelMortgage}
                    </div>
                    <div className={cssIsDisabledOtherMortgagesSpan}>
                        <span className='mortgage-request-other-loans-responsive__mr-1'>
                            {formatText("mortgageRequestPreApproval-mortgageRequestPreApproval_otherMortgageMonthlyFees")}
                        </span>
                        <span>
                            {formatText("mortgageRequestPreApproval-approximateAmount")}
                        </span>
                    </div>
                    <div className={cssIsDisabledOhterMortgaggesInputs}>
                        <div className="mortgage-request-other-loans-responsive__container-input mortgage-request-other-loans-responsive__mb-2">
                            {monthlyFeesMortgages}
                        </div>
                    </div>
                    <div className={cssIsDisabledOtherMortgagesSpan}>
                        <span className='mortgage-request-other-loans-responsive__mr-1'>
                            {formatText("mortgageRequestPreApproval-mortgageRequestPreApproval_otherMortgagePendingAmount")}
                        </span>
                        <span>
                            {formatText("mortgageRequestPreApproval-approximateAmount")}
                        </span>
                    </div>
                    <div className={cssIsDisabledOhterMortgaggesInputs}>
                        <div className="mortgage-request-other-loans-responsive__container-input mortgage-request-other-loans-responsive__mb-2">
                            {pendingAmountMortgages}
                        </div>
                    </div>
                </div>
            </>
        );
    }
    buildOtherMortgage(isSecondHolder) {
        const propsDisabledFields = this.validateStateFieldsOtherMortgages(isSecondHolder);
        const cssColTitles = classNames(
            'mortgage-request-other-loans__container-title', {
                'col-md-5': isSecondHolder,
                'col-md-7': !isSecondHolder
            });

        const cssIsDisabledRadio = classNames(
            'col-md-12', {
                'mortgage-request-other-loans__disable':
                    propsDisabledFields.disabledGoingCancelMortgageOne && propsDisabledFields.disabledGoingCancelMortgageTwo
            });

        const cssIsDisabledInputs = classNames(
            'col-md-12 ', {
                'mortgage-request-other-loans__disable':
                    propsDisabledFields.disabledMonthlyAndPendingAmountOne && propsDisabledFields.disabledMonthlyAndPendingAmountTwo
            });

        const cssColRadios = classNames(
            'col-md-offset-1',
            'mortgage-request-other-loans__container-radio', {
                'col-md-3': isSecondHolder,
                'col-md-1': !isSecondHolder
            });

        const cssColInputs = classNames(
            'col-md-offset-1',
            'mortgage-request-other-loans__container-input', {
                'col-md-3': isSecondHolder,
                'col-md-1': !isSecondHolder
            });

        const firstOtherMortgageRadio = this.buildOtherMortgageRadio(HOLDER_OPTION_ONE);
        const secondOtherMortgageRadio = isSecondHolder ? this.buildOtherMortgageRadio(HOLDER_OPTION_TWO) : null;
        const firstGoingCancelMortgage = this.buildGoingCancelMortgageRadio(HOLDER_OPTION_ONE, propsDisabledFields.disabledGoingCancelMortgageOne);
        const secondGoingCancelMortgage = isSecondHolder ? this.buildGoingCancelMortgageRadio(HOLDER_OPTION_TWO, propsDisabledFields.disabledGoingCancelMortgageTwo) : null;
        const firstMonthlyFeesMortgages = this.buildMonthlyFeesMortgages(HOLDER_OPTION_ONE, propsDisabledFields.disabledMonthlyAndPendingAmountOne);
        const secondMonthlyFeesMortgages = isSecondHolder ? this.buildMonthlyFeesMortgages(HOLDER_OPTION_TWO, propsDisabledFields.disabledMonthlyAndPendingAmountTwo) : null;
        const firstPendingAmountMortgages = this.buildPendingAmountMortgages(HOLDER_OPTION_ONE, propsDisabledFields.disabledMonthlyAndPendingAmountOne);
        const secondPendingAmountMortgages = isSecondHolder ? this.buildPendingAmountMortgages(HOLDER_OPTION_TWO, propsDisabledFields.disabledMonthlyAndPendingAmountTwo) : null;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className={cssColTitles}>
                        <FormattedText className="mortgage-request-other-loans__bold-title" value="mortgageRequestPreApproval-otherMortgages" />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-radio">
                        {firstOtherMortgageRadio}
                    </div>
                    <div className={cssColRadios}>
                        {secondOtherMortgageRadio}
                    </div>
                </div>
                <div className={cssIsDisabledRadio}>
                    <div className={cssColTitles}>
                        <FormattedText
                            className="mortgage-request-other-loans__regular-title"
                            value="mortgageRequestPreApproval-goingCancelMortgage"
                        />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-radio">
                        {firstGoingCancelMortgage}
                    </div>
                    <div className={cssColRadios}>
                        {secondGoingCancelMortgage}
                    </div>
                </div>
                <div className={cssIsDisabledInputs}>
                    <div className={cssColTitles}>
                        <FormattedText
                            className="mortgage-request-other-loans__text mortgage-request-other-loans__text--large-width"
                            value="mortgageRequestPreApproval-mortgageRequestPreApproval_otherMortgageMonthlyFees"
                        />
                        <FormattedText
                            className="mortgage-request-other-loans__subtitle"
                            value="mortgageRequestPreApproval-approximateAmount"
                        />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-input">
                        {firstMonthlyFeesMortgages}
                    </div>
                    <div className={cssColInputs}>
                        {secondMonthlyFeesMortgages}
                    </div>
                </div>
                <div className={cssIsDisabledInputs}>
                    <div className={cssColTitles}>
                        <FormattedText
                            className="mortgage-request-other-loans__text mortgage-request-other-loans__text--medium-width"
                            value="mortgageRequestPreApproval-mortgageRequestPreApproval_otherMortgagePendingAmount"
                        />
                        <FormattedText
                            className="mortgage-request-other-loans__subtitle"
                            value="mortgageRequestPreApproval-approximateAmount"
                        />
                    </div>
                    <div className="col-md-3 mortgage-request-other-loans__container-input">
                        {firstPendingAmountMortgages}
                    </div>
                    <div className={cssColInputs}>
                        {secondPendingAmountMortgages}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immMortgageRequest, responsiveMobileVersion } = this.props;
        const isSecondHolder = isEqual(immMortgageRequest.get('selectedHolder'), HOLDER_OPTION_TWO);
        const title = (<FormattedText value="mortgageRequestPreApprovalStepThree-others" />);
        const subTitle = (<FormattedText value="mortgageRequestPreApproval-subtitleOtherLoans" />);
        const personalLoans = this.buildPersonalLoans(isSecondHolder);
        const personalLoansResponsiveOneHolder = this.buildPersonalLoansResponisveHolder(isSecondHolder, HOLDER_OPTION_ONE);
        const personalLoansResponsiveTwoHolder = isSecondHolder && this.buildPersonalLoansResponisveHolder(isSecondHolder, HOLDER_OPTION_TWO);
        const otherMortgages = this.buildOtherMortgage(isSecondHolder);
        const cssOffsetTitle = classNames(
            'mortgage-request-other-loans__bold-title',
            'col-md-4', {
                'col-md-offset-5': isSecondHolder,
                'col-md-offset-7': !isSecondHolder
            });

        return (
            <div className="row mortgage-request-other-loans">
                <div className="col-md-11">
                    <OKBoxTitle value={title} children={subTitle} size="medium" />
                </div>
                {responsiveMobileVersion ?
                    <>
                        <div className='container-fluid'>
                            {personalLoansResponsiveOneHolder}
                            <div className="mortgage-request-other-loans__separator-line" />
                            {personalLoansResponsiveTwoHolder}
                        </div>

                    </>
                    :
                    <>
                        <div className="col-md-12">
                            <FormattedText className={cssOffsetTitle} value="mortgageRequestPreApproval-firstHolder" />
                            {isSecondHolder && <FormattedText className="mortgage-request-other-loans__bold-title col-md-3" value="mortgageRequestPreApproval-secondtHolder" />}
                        </div>
                        {personalLoans}
                        <div className="mortgage-request-other-loans__separator-line" />
                        {otherMortgages}
                    </>
                }

            </div>
        );
    }
}

MortgageRequestOtherLoans.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object.isRequired
}

module.exports = MortgageRequestOtherLoans;
